//Margin Component for Funnel Chart
import React from 'react';
import SliderWithInput from '../../SliderWithInput';

interface FunnelMarginsProps {
  top: number;
  bottom: number;
  funnelLeft: number;
  funnelRight: number;
  onChange: (option: string, value: number) => void;
  minMax?: { min: number; max: number; step: number };
  iconColor?: string;
}

const FunnelMargins: React.FC<FunnelMarginsProps> = ({
  top,
  bottom,
  funnelLeft,
  funnelRight,
  onChange,
  minMax = { min: 0, max: 50, step: 1 },
  iconColor,
}) => {
  return (
    <>
      <div
        className="optionDescription"
        style={{
          marginTop: '0px',
          paddingTop: '8px',
          color: iconColor ? iconColor : '#404040',
        }}
      >
        MARGIN RESIZE
      </div>
      <div
        className="optionDescription"
        style={{
          marginTop: '0',
          color: iconColor ? iconColor : '#404040',
        }}
      >
        Top
      </div>
      <SliderWithInput
        percent={true}
        sliderValue={top}
        sliderMinMax={minMax}
        changeValue={(value) => onChange('top', value)}
      />
      <div className="optionDescription" style={{ color: iconColor ? iconColor : '#404040' }}>
        Bottom
      </div>
      <SliderWithInput
        percent={true}
        sliderValue={bottom}
        sliderMinMax={minMax}
        changeValue={(value) => onChange('bottom', value)}
      />
      <div className="optionDescription" style={{ color: iconColor ? iconColor : '#404040' }}>
        Left
      </div>
      <SliderWithInput
        percent={true}
        sliderValue={funnelLeft}
        sliderMinMax={minMax}
        changeValue={(value) => onChange('funnelLeft', value)}
      />
      <div className="optionDescription" style={{ color: iconColor ? iconColor : '#404040' }}>
        Right
      </div>
      <SliderWithInput
        percent={true}
        sliderValue={funnelRight}
        sliderMinMax={minMax}
        changeValue={(value) => onChange('funnelRight', value)}
      />
    </>
  );
};

export default FunnelMargins;
